
export const CONFIRMED_CREATE_PATIENT_MALE_CHART = "CONFIRMED_CREATE_PATIENT_MALE_CHART"
export const CONFIRMED_DELETE_PATIENT_MALE_CHART = "CONFIRMED_DELETE_PATIENT_MALE_CHART"
export const CONFIRMED_EDIT_PATIENT_MALE_CHART = "CONFIRMED_EDIT_PATIENT_MALE_CHART"
export const CONFIRMED_GET_PATIENT_MALE_CHARTS = "CONFIRMED_GET_PATIENT_MALE_CHARTS"
